import { create } from 'zustand';

/**
 * Tracks whether the hero's own filter bar (rendered by {@link ActivitySearchFiltersOverlay})
 * is still in the viewport. Once it scrolls away, the page may offer a duplicate control —
 * a sticky filter bar, the floating mode tabs — without the two being on screen at once.
 */
export const useActivitySearchHeroBarInViewStore = create<{
    heroBarInView: boolean;
    setHeroBarInView: (inView: boolean) => void;
}>(set => ({
    heroBarInView: true,
    setHeroBarInView: heroBarInView => set({ heroBarInView }),
}));
